// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "电气设备状态监测与故障诊断",
      "tec": "钟丹田",
      "week": "1,3,5,7周",
      "add": "教学楼A座218电力"
    },
    {
      "sub": "MATLAB数值分析与应用",
      "tec": "冷雪",
      "week": "1-4周",
      "add": "实训楼C座318"
    },
    0,
    0,
    0
  ],
  "2": [
    0,
    {
      "sub": "电力系统智能控制",
      "tec": "卢奭瑄",
      "week": "1-8周",
      "add": "教学楼C座111教务"
    },
    0,
    0,
    0
  ],
  "3": [
    {
      "sub": "电气设备状态监测与故障诊断",
      "tec": "钟丹田",
      "week": "1-8周",
      "add": "教学楼A座220电力"
    },
    0,
    0,
    0,
    0
  ],
  "4": [
    {
      "sub": "MATLAB数值分析与应用",
      "tec": "冷雪",
      "week": "1-4周",
      "add": "实训楼C座318"
    },
    0,
    0,
    0,
    0
  ],
  "5": [
    {
      "sub": "电力系统智能控制",
      "tec": "卢奭瑄",
      "week": "1-8周",
      "add": "教学楼A座219电力"
    },
    0,
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
